import React, { Component } from 'react';
import Nav from './component/nav';
import Panel from './component/panel';
import PanelData from './component/global';
import Form from './component/form';

const axios = require('axios')

const createNewEvent = (eventName) => {
  var event;
  if (typeof(Event) === 'function') {
      event = new Event(eventName);
  } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
  }
  return event;
}
//dev
// const sitePath = ''
// const hostname = 'http://localhost:4000/'
// const hostSession = 'https://planview1s.wpengine.com'
//prod
const sitePath = '/lps/surveys/spigit-innovation'
const hostname = 'https://marketing.planview.com/'
const hostSession = window.location.protocol + '//' + window.location.hostname;
const session = new Date().getTime()
class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      options: [],
      data: [],
      index: 1,
      showResult: true,
      busy: false
    }
    this.Form = React.createRef();
  }
  componentDidMount() {
    window.MktoForms2.loadForm("//app-ab22.marketo.com", "456-QCH-520", 2351, function(form){

      var script = document.createElement("script");
      var head = document.head || document.getElementsByTagName("head")[0];
      script.type = "text/javascript";
      script.src = "//sfc.leadspace.com/SmartForms.js"; 
      script.dataset.token = "351";
      head.appendChild(script);
      // SF4 capture event as parameter
      window.companyUpdate = createNewEvent('update')
      document.getElementById("Company").addEventListener("update", function(e){
        // window.sf$.fieldChanged(e)
        window.sf$.sf5.handlers.fieldChangedHandler(e)
			});

      window.myForm = form
    })
  }
  setData(e, answer, score, redirect){
    let options = this.state.options
    let answerID = e.target.value
    if (e.target.type === 'radio'){
      options[0] = {answerID, answer, score, redirect}
    }else{
      if (e.target.checked){
        if (answer === 'None' || answer === 'All the above'){
          options = []
        }
        options.push({answerID, answer, score})
      }else{
        options = options.filter(item => item.answerID !== answerID)
      }
      this.setState({options})
    }
  }
  goNext(){
    if (this.state.options.length > 0) {
      if (this.state.options[0].redirect) {
        window.location.href = sitePath + '/no-result.html'
      }else{
        let temp = this.state.data
        temp[this.state.index - 1] = this.state.options
        this.setState({
          index: this.state.index + 1,
          data: temp,
          options: []
        })
      }
    }
  }
  goBack(){
    let index = this.state.index - 1
    this.setState({
      index: index,
      options: this.state.data[index - 1]
    })
  }
  submitData(){
    
    let form = this.Form.current
    if (form.is_fields_ok()){
      const {email} = this.Form.current.state
      let formattedData = this.formatData(this.state.data)
      window.myForm.addHiddenFields({
        Survey_Name_Admin_Only: 'Spigit Innovation Benchmark Program',
        Survey_Results_Link_Admin_Only: hostSession + '/lps/surveys/admin/session/innovation/' +session
      })
      let payload = {
        session: session,
        host: hostSession,
        person : email,
        level: formattedData.level,
        InnovationData: formattedData.innvationData
      }
      console.log(payload)
      // var x = document.querySelector('#mktoForm_2351 button.mktoButton');
      // x.click()
      // this.setState({busy: true})
      // let that = this
      // window.myForm.onSuccess(function(values, followUpUrl) {
      //   axios.post(hostname + 'api/innovation', {
      //     action: 'save',
      //     payload: payload
      //   }).then( function(res) {
      //     console.log(res.data)
      //     that.setState({busy: false})
      //     window.location.href = sitePath + '/result.html?level=' + formattedData.level
      //   }).catch(err => {
      //     that.setState({busy: false})
      //     console.error(err)
      //   })
      //   return false
      // })
    }
  }
  formatData(data){
    const levels= {
      1: 'Beginner',
      2: 'Intermediate',
      3: 'Advanced'
    }
    let innvationData = [], total = 0, avg = 0
    data.forEach((answers, question_id) => {
      answers.forEach((item, i) => {
        total += item.score
        innvationData.push({
          question_id: question_id,
          answer_id: item.answer,
          answer_score: item.score
        })
      })
    })
    avg = Math.floor(total / innvationData.length)
    let level = levels[avg]
    return {innvationData, level}
  }
  render() {
    return (
      <section className={`app ${this.state.index > PanelData.length ? 'form-mode' : ''}`}>
          <Nav index={this.state.index} count={PanelData.length} />
          <div className="panel-wrapper">
            {
              PanelData.map((e, i) => (
                <Panel key={i} active={(this.state.index - 1) === i} index={i} data={e} setData={this.setData.bind(this)} />
              ))
            }
            { this.state.index === PanelData.length + 1 &&
              <Form ref={this.Form} active={this.state.index > PanelData.length} />
            }            
          </div>
          <div className={`button-wrapper ${this.state.busy ? "busy" : ""}`}>
          { this.state.index > 1 &&
            <button className="tertiary back" onClick={this.goBack.bind(this)}>Back</button>
          }
          { this.state.index <= PanelData.length &&
            <button className="tertiary next" onClick={this.goNext.bind(this)}>Next question</button>
          }
          { this.state.index === PanelData.length + 1 &&
            <>
              <button onClick={this.submitData.bind(this)} className="button large primary">Results</button>
              <p className="consent">By submitting this form you agree to our <a href="https://www.planview.com/trust/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>
            </>
          }
        </div>
      </section>
    );
  }
}

export default App;
